(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2717],{

/***/ 72717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ AppliedFilters; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/atomic/AppliedFilters/applied-filters.module.scss
var applied_filters_module = __webpack_require__(71087);
var applied_filters_module_default = /*#__PURE__*/__webpack_require__.n(applied_filters_module);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/filters.js
var lib_filters = __webpack_require__(46850);
// EXTERNAL MODULE: ./lib/utilities/search.js
var utilities_search = __webpack_require__(45425);
;// CONCATENATED MODULE: ./components/atomic/AppliedFilters/AppliedFilters.js






var AppliedFilters = function(param) {
    var search = param.search, ranges = param.ranges, vehicleTags = param.vehicleTags, vehiclePriceTags = param.vehiclePriceTags, _hideDefaults = param.hideDefaults, hideDefaults = _hideDefaults === void 0 ? false : _hideDefaults, _separator = param.separator, separator = _separator === void 0 ? ", " : _separator, _className = param.className, className = _className === void 0 ? "" : _className, _filterLimit = param.filterLimit, filterLimit = _filterLimit === void 0 ? 3 : _filterLimit;
    var ref, ref1, ref2, ref3;
    var allAppliedFilters = [];
    var getMonthlyPayment = function() {
        var ref, ref1;
        var min = search.searchRequest.monthlyPaymentMin;
        var max = search.searchRequest.monthlyPaymentMax;
        var maxValue = Math.floor(((ref = search.searchRequest.leaseTypes) === null || ref === void 0 ? void 0 : ref[0]) === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ ? (0,utilities_search/* addVatToPrice */.QR)(search.searchRequest.monthlyPaymentMax) : search.searchRequest.monthlyPaymentMax);
        var minValue = Math.floor(((ref1 = search.searchRequest.leaseTypes) === null || ref1 === void 0 ? void 0 : ref1[0]) === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ ? (0,utilities_search/* addVatToPrice */.QR)(search.searchRequest.monthlyPaymentMin) : search.searchRequest.monthlyPaymentMin);
        if (min === undefined && max > 8000000) {
            return "Any Budget";
        }
        if (!!min && !!max) {
            return "\xa3".concat((0,utilities_search/* formatWithCommas */.b1)(minValue)).concat(max > constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD ? "+" : " to \xa3".concat((0,utilities_search/* formatWithCommas */.b1)(maxValue)));
        }
        if (min === undefined && !!max) {
            return "\xa30 to \xa3".concat(maxValue > constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD ? (0,utilities_search/* formatWithCommas */.b1)(constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD) : (0,utilities_search/* formatWithCommas */.b1)(maxValue));
        }
        return "Any Budget";
    };
    var getInitialPayment = function() {
        var ref, ref1;
        var min = search.searchRequest.initialPaymentMin;
        var max = search.searchRequest.initialPaymentMax;
        var maxValue = Math.floor(((ref = search.searchRequest.leaseTypes) === null || ref === void 0 ? void 0 : ref[0]) === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ ? (0,utilities_search/* addVatToPrice */.QR)(search.searchRequest.initialPaymentMax) : search.searchRequest.initialPaymentMax);
        var minValue = Math.floor(((ref1 = search.searchRequest.leaseTypes) === null || ref1 === void 0 ? void 0 : ref1[0]) === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ ? (0,utilities_search/* addVatToPrice */.QR)(search.searchRequest.initialPaymentMin) : search.searchRequest.initialPaymentMin);
        if (min === undefined && max > 8000000) {
            return "Any Budget";
        }
        if (!!min && !!max) {
            return "\xa3".concat(minValue).concat(max > constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf ? "+" : " to \xa3".concat(maxValue));
        }
        if (min === undefined && !!max) {
            return "\xa30 to \xa3".concat((0,utilities_search/* formatWithCommas */.b1)(constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf));
        }
        return "Any Budget";
    };
    var getCapacityRange = function(min, max) {
        var capacityType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        var onlyMaxValueExists = (min === 0 || min === null) && !!max;
        if (capacityType === constants/* FILTER_CAPACITY_PAYLOAD */.$P) {
            return "".concat(onlyMaxValueExists ? "0" : (0,utilities_search/* convertToTonnes */.t5)(min), "t to ").concat((0,utilities_search/* convertToTonnes */.t5)(max), "t");
        } else {
            return "".concat(onlyMaxValueExists ? "0" : (0,utilities_search/* convertToMetres */.cR)(min), "m to ").concat((0,utilities_search/* convertToMetres */.cR)(max), "m");
        }
    };
    var getRangeName = function(filter) {
        var ref, ref1;
        return ((ref = ranges === null || ranges === void 0 ? void 0 : ranges.filter(function(range) {
            return range.id === filter;
        })) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.name) || null;
    };
    var getVehicleTagName = function(filter) {
        var ref;
        return (ref = vehicleTags === null || vehicleTags === void 0 ? void 0 : vehicleTags.filter(function(tag) {
            return tag.id === filter;
        })[0]) === null || ref === void 0 ? void 0 : ref.name;
    };
    var getFilterName = function(filter, type) {
        var foundFilter = lib_filters/* FILTERS */.O[type].filter(function(item) {
            return item.id === filter;
        });
        return foundFilter.length > 0 && !!foundFilter[0].name ? foundFilter[0].name : null;
    };
    var getPerformanceText = function(id) {
        var filters = lib_filters/* FILTERS.performance.filter */.O.performance.filter(function(filter) {
            return filter.id === id;
        });
        var filterName = filters.length > 0 && !!filters[0].name ? filters[0].name : null;
        if (filterName) {
            if (id >= 1 && id <= 25) {
                return "CO2: ".concat(filterName, "g/km");
            }
            if (id >= 26 && id <= 36) {
                return "MPG: ".concat(filterName, "mpg");
            }
            if (id >= 37 && id <= 44 || id >= 441 && id <= 450) {
                return "0 to 62: ".concat(filterName, "s");
            }
            if (id >= 45 && id <= 53) {
                return "Min Engine: ".concat(filterName, "L");
            }
            if (id >= 54 && id <= 62) {
                return "Max Engine: ".concat(filterName, "L");
            }
        }
    };
    var getSpecFilterName = function(id) {
        var specArray = [];
        lib_filters/* FILTERS.spec.map */.O.spec.map(function(item) {
            if (item.subFilters) {
                var _specArray;
                item.subFilters.map(function() {
                    return (_specArray = specArray).push.apply(_specArray, (0,_to_consumable_array/* default */.Z)(item.subFilters));
                });
            }
            return specArray.push(item);
        });
        var filteredArray = specArray.filter(function(spec) {
            return spec.id === id;
        });
        var name = filteredArray.length > 0 && !!filteredArray[0].name ? filteredArray[0].name : null;
        if (id >= 43016 && id <= 43022) {
            name = "".concat(name, '" Alloys');
        }
        return name;
    };
    if (!hideDefaults && !!search.searchRequest.vehicleTypes) {
        search.searchRequest.vehicleTypes.forEach(function(filter) {
            return allAppliedFilters.push(filter === constants/* FILTER_VEHICLE_TYPES_VANS */.Bz ? "Vans" : "Cars");
        });
    }
    if (!hideDefaults && !search.searchRequest.vehicleTypes) {
        allAppliedFilters.push("Cars");
    }
    if (!hideDefaults && search.searchRequest.leaseTypes.length > 0) {
        search.searchRequest.leaseTypes.forEach(function(filter) {
            return allAppliedFilters.push(filter === 1 ? "Business" : "Personal");
        });
    }
    if (!!search.searchRequest.vehicleTags && search.searchRequest.vehicleTags.length > 0) {
        search.searchRequest.vehicleTags.forEach(function(filter) {
            var filterName = getVehicleTagName(filter);
            if (!filterName) {
                return false;
            }
            allAppliedFilters.push(filterName);
        });
    }
    if (!!search.searchRequest.vehiclePriceTags && search.searchRequest.vehiclePriceTags.length > 0) {
        search.searchRequest.vehiclePriceTags.map(function(filter) {
            var filterDetails = vehiclePriceTags === null || vehiclePriceTags === void 0 ? void 0 : vehiclePriceTags.filter(function(tag) {
                return tag.id === filter.vehiclePriceTagCategoryId;
            });
            var categories = vehiclePriceTags === null || vehiclePriceTags === void 0 ? void 0 : vehiclePriceTags.filter(function(tag) {
                return tag.id === filter.vehiclePriceTagCategoryId;
            });
            if ((filterDetails === null || filterDetails === void 0 ? void 0 : filterDetails.length) === 0) {
                return false;
            }
            if (filter.vehiclePriceTagCategoryId === 3 && (filterDetails === null || filterDetails === void 0 ? void 0 : filterDetails.length) > 0) {
                var category = vehiclePriceTags.find(function(vpt) {
                    return vpt.id === 3;
                });
                var selectedLeadTimeTags = filter.vehiclePriceTagIds.map(function(tagId) {
                    var ref;
                    return (ref = category.vehiclePriceTags) === null || ref === void 0 ? void 0 : ref.find(function(t) {
                        return t.id === tagId;
                    });
                });
                return allAppliedFilters.push(selectedLeadTimeTags.sort(function(a, b) {
                    return a.priority - b.priority;
                }).map(function(i) {
                    return (i === null || i === void 0 ? void 0 : i.shortLabel) || (i === null || i === void 0 ? void 0 : i.name);
                }).join(", "));
            }
            if (!!categories && categories.length > 0) {
                allAppliedFilters.push(categories[0].name);
            }
        });
    }
    {
        search.searchRequest.terms.length > 0 && allAppliedFilters.push(search.searchRequest.terms.map(function(filter) {
            return (0,utilities_search/* getTermsFilterName */.lB)(filter);
        }).join(separator));
    }
    {
        search.searchRequest.mileages.length > 0 && allAppliedFilters.push(search.searchRequest.mileages.map(function(filter) {
            return "".concat((0,utilities_search/* formatWithCommas */.b1)(filter), " mi");
        }).join(separator));
    }
    {
        search.searchRequest.manufacturers.length > 0 && allAppliedFilters.push(search.searchRequest.manufacturers.map(function(filter) {
            return getFilterName(filter, constants/* FILTER_MANUFACTURERS */.Gz);
        }));
    }
    {
        search.searchRequest.ranges.length > 0 && allAppliedFilters.push(search.searchRequest.ranges.map(function(filter) {
            return getRangeName(filter);
        }));
    }
    {
        search.searchRequest.fuelTypes.length > 0 && allAppliedFilters.push(search.searchRequest.fuelTypes.map(function(filter) {
            return (0,utilities_search/* fuelTypeAbbreviation */.HW)(getFilterName(filter, constants/* FILTER_FUEL_TYPES */.pF));
        }));
    }
    {
        search.searchRequest.driveTypes.length > 0 && allAppliedFilters.push(search.searchRequest.driveTypes.map(function(filter) {
            return getFilterName(filter, constants/* FILTER_DRIVE_TYPES */.Jw);
        }));
    }
    {
        search.searchRequest.transmissionTypes.length > 0 && allAppliedFilters.push(search.searchRequest.transmissionTypes.map(function(filter) {
            return getFilterName(filter, constants/* FILTER_TRANSMISSION_TYPES */.dw);
        }));
    }
    {
        search.searchRequest.bodyStyles.length > 0 && allAppliedFilters.push(search.searchRequest.bodyStyles.map(function(filter) {
            return getFilterName(filter, constants/* FILTER_BODY_STYLES */.EK);
        }));
    }
    {
        search.searchRequest.doors.length > 0 && allAppliedFilters.push(search.searchRequest.doors.map(function(filter) {
            return "".concat(filter, " Doors");
        }));
    }
    {
        search.searchRequest.seats.length > 0 && allAppliedFilters.push(search.searchRequest.seats.map(function(filter) {
            return "".concat(filter, " Seats");
        }));
    }
    {
        search.searchRequest.performance.length > 0 && search.searchRequest.performance[0] !== 0 && allAppliedFilters.push(search.searchRequest.performance.map(function(filter) {
            return getPerformanceText(filter);
        }));
    }
    {
        search.searchRequest.spec.length > 0 && allAppliedFilters.push(search.searchRequest.spec.map(function(filter) {
            return getSpecFilterName(filter);
        }));
    }
    {
        search.searchRequest.features && search.searchRequest.features.length > 0 && allAppliedFilters.push(search.searchRequest.features.map(function(filter) {
            return getFilterName(filter, constants/* FILTER_FEATURES */.Ls);
        }));
    }
    {
        search.searchRequest.wheelbase && search.searchRequest.wheelbase.length > 0 && allAppliedFilters.push(search.searchRequest.wheelbase.map(function(filter) {
            return "Wheelbase: ".concat(getFilterName(filter, constants/* FILTER_WHEELBASE */.cA));
        }));
    }
    {
        search.searchRequest.roofHeight && search.searchRequest.roofHeight.length > 0 && allAppliedFilters.push(search.searchRequest.roofHeight.map(function(filter) {
            return "Roof Height: ".concat(getFilterName(filter, constants/* FILTER_ROOF_HEIGHT */.aW));
        }));
    }
    if (!!search.searchRequest.payloadMin || !!search.searchRequest.payloadMax) {
        allAppliedFilters.push("Payload: ".concat(getCapacityRange(search.searchRequest.payloadMin, search.searchRequest.payloadMax, constants/* FILTER_CAPACITY_PAYLOAD */.$P)));
    }
    if (!!search.searchRequest.loadHeightMin || !!search.searchRequest.loadHeightMax) {
        allAppliedFilters.push("Load Height: ".concat(getCapacityRange(search.searchRequest.loadHeightMin, search.searchRequest.loadHeightMax)));
    }
    if (!!search.searchRequest.loadLengthMin || !!search.searchRequest.loadLengthMax) {
        allAppliedFilters.push("Load Length: ".concat(getCapacityRange(search.searchRequest.loadLengthMin, search.searchRequest.loadLengthMax)));
    }
    if (!!search.searchRequest.loadWidthMin || !!search.searchRequest.loadWidthMax) {
        allAppliedFilters.push("Load Width: ".concat(getCapacityRange(search.searchRequest.loadWidthMin, search.searchRequest.loadWidthMax)));
    }
    if (search.searchRequest.inStock) {
        allAppliedFilters.push("In Stock Only");
    }
    if ((ref = search.searchRequest.electricBatteryCapacity) === null || ref === void 0 ? void 0 : ref.length) {
        allAppliedFilters.push((0,utilities_search/* getElectricFilterLabelPrettyName */.XO)(constants/* FILTER_ELECTRIC_BATTERY_CAPACITY */.Bc, search.searchRequest.electricBatteryCapacity[0]));
    }
    if ((ref1 = search.searchRequest.electricFastestChargeRate) === null || ref1 === void 0 ? void 0 : ref1.length) {
        allAppliedFilters.push((0,utilities_search/* getElectricFilterLabelPrettyName */.XO)(constants/* FILTER_ELECTRIC_FASTEST_CHARGE_RATE */.V2, search.searchRequest.electricFastestChargeRate[0]));
    }
    if ((ref2 = search.searchRequest.electricHomeChargeTime) === null || ref2 === void 0 ? void 0 : ref2.length) {
        allAppliedFilters.push((0,utilities_search/* getElectricFilterLabelPrettyName */.XO)(constants/* FILTER_ELECTRIC_HOME_CHARGE_TIME */.zc, search.searchRequest.electricHomeChargeTime[0]));
    }
    if ((ref3 = search.searchRequest.electricRange) === null || ref3 === void 0 ? void 0 : ref3.length) {
        allAppliedFilters.push((0,utilities_search/* getElectricFilterLabelPrettyName */.XO)(constants/* FILTER_ELECTRIC_RANGE */.EH, search.searchRequest.electricRange[0]));
    }
    if (hideDefaults && getMonthlyPayment() !== "Any Budget" || !hideDefaults) {
        allAppliedFilters.push("Monthly: ".concat(getMonthlyPayment()));
    }
    if (hideDefaults && getInitialPayment() !== "Any Budget" || !hideDefaults) {
        allAppliedFilters.push("Upfront: ".concat(getInitialPayment()));
    }
    if (!!search.searchRequest.searchTerm && search.searchRequest.searchTerm.length > 0) {
        allAppliedFilters.push("Text Search: ".concat(search.searchRequest.searchTerm));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((applied_filters_module_default()).container, " ").concat(className, " applied-filters"),
        children: [
            allAppliedFilters.slice(0, filterLimit ? filterLimit : allAppliedFilters.length).join(separator),
            filterLimit && allAppliedFilters.slice(filterLimit).length > 0 && " + ".concat(allAppliedFilters.slice(filterLimit).length, " more")
        ]
    });
};

;// CONCATENATED MODULE: ./components/atomic/AppliedFilters/index.js



/***/ }),

/***/ 71087:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"applied-filters_container__2YTou","phAnimation":"applied-filters_phAnimation__olKkc"};

/***/ })

}]);